/**
 * **The Autho Assistant's avatar, in the app** (F529; BRAND.md *The agent avatar* and *Motion*): the helmet seen from
 * the front, its visor saying what the assistant or an agent is doing. Plain SVG and CSS (`avatar.css`), no animation
 * library: the geometry is the reference implementation's (`brand/agent/avatar-motion.html`), and each state's cycle
 * is BRAND.md's, at strength 1×. With *reduce motion* on, or `still`, nothing moves: *needs you* keeps a static halo
 * and *responding* a static glass. Slack, email and the favicons keep the static SVGs in `brand/`.
 */
export const AVATAR_STATES = ['idle', 'working', 'responding', 'needs-you', 'stopped'] as const;
export type AvatarState = (typeof AVATAR_STATES)[number];

export interface AvatarProps {
  state: AvatarState;
  /** Pixels, square. BRAND.md: the mark is 24 px at the least. */
  size?: number;
  /** What the avatar says, for a screen reader; without one it is decoration beside words that say it. */
  label?: string;
  /** No motion even where motion is allowed: an earlier answer, a list of many. */
  still?: boolean;
  className?: string;
}

export function Avatar({ state, size = 24, label, still = false, className }: AvatarProps) {
  return (
    <svg
      className={className ? `autho-avatar ${className}` : 'autho-avatar'}
      data-state={state}
      data-still={still ? 'true' : undefined}
      data-testid="avatar"
      viewBox="150 150 780 780"
      width={size}
      height={size}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      <circle className="av-halo" cx="540" cy="540" r="360" />
      <circle className="av-ring" cx="540" cy="540" r="300" />
      <rect className="av-glass" x="293.5" y="432.8" width="493" height="214.4" rx="92" />
      <rect className="av-visor" x="293.5" y="432.8" width="493" height="214.4" rx="92" />
      <rect className="av-bar" x="340" y="520" width="112" height="40" rx="20" />
    </svg>
  );
}
